class HomeDescriptionController {
  constructor (AppConfig, I18n) {
    'ngInject'
    this.paragraphs = AppConfig.pages.home.paragraphs
    this.I18n = I18n
  }
}

export default HomeDescriptionController



// WEBPACK FOOTER //
// ./src/app/pages/home/description/home-description.controller.js